<template>
  <div class="checkLoginDiv">
    <div class="checkLogin">
      <img src="./login.png" alt="" />
      <template v-if="type == 1">
        <p>Windows 管理后台确认登录</p>
      </template>
      <template v-if="type == 2">
        <p>已确认登录,请关闭页面</p>
      </template>
      <template v-if="type == 3">
        <p>已取消登录,请关闭页面</p>
      </template>
      <template v-if="type == 1">
        <p><van-button type="primary" @click="login">确认登录</van-button></p>
        <p><van-button type="default" @click="cancel">取消登录</van-button></p>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: {},
  data() {
    return {
      com_id: "",
      uid: "",
      type: 1
    };
  },
  watch: {},
  components: {},
  async mounted() {},
  methods: {
    login() {
      this.$common
        .http({
          method: "get",
          url: `/api/authorize/wxwork_qrcode_login_confirm?com_id=${this.com_id}&uid=${this.uid}`
        })
        .then(res => {
          let status = res.data.data.status;
          if (status == "INVALID") {
            this.$common.mbToastSuccess("无效二维码");
          } else if (status == "WAIT") {
            this.$common.mbToastSuccess("待扫码");
          } else if (status == "SCANED") {
            this.$common.mbToastSuccess("已扫码");
          } else if (status == "CONFIRM") {
            this.$common.mbToastSuccess("已确认登录");
            this.type = 2;
          } else if (status == "CANCEL") {
            this.$common.mbToastSuccess("已取消登录");
          } else if (status == "NO_PERMISSION") {
            this.$common.mbToastFail("无权限");
          } else if (status == "ACCOUNT_INVALID") {
            this.$common.mbToastFail("账号不存在");
          } else {
            this.$common.mbToastFail("无效status值");
          }
        });
    },
    cancel() {
      this.$common
        .http({
          method: "get",
          url: `/api/authorize/wxwork_qrcode_login_cancel?com_id=${this.com_id}&uid=${this.uid}`
        })
        .then(res => {
          let status = res.data.data.status;
          if (status == "INVALID") {
            this.$common.mbToastSuccess("无效二维码");
          } else if (status == "WAIT") {
            this.$common.mbToastSuccess("待扫码");
          } else if (status == "SCANED") {
            this.$common.mbToastSuccess("已扫码");
          } else if (status == "CONFIRM") {
            this.$common.mbToastSuccess("已确认登录");
          } else if (status == "CANCEL") {
            this.$common.mbToastSuccess("已取消登录");
            this.type = 3;
          } else if (status == "NO_PERMISSION") {
            this.$common.mbToastFail("无权限");
          } else if (status == "ACCOUNT_INVALID") {
            this.$common.mbToastFail("账号不存在");
          } else {
            this.$common.mbToastFail("无效status值");
          }
        });
    }
  },
  created() {
    this.com_id = this.$route.query.com_id;
    this.uid = this.$route.query.uid;
  }
};
</script>
<style lang="less" scoped>
.checkLoginDiv {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  .checkLogin {
    text-align: center;
    img {
      width: 260px;
    }
    p {
      text-align: center;
    }
    button {
      width: 94vw;
    }
  }
}
</style>
